namespace Matrix.Data {
    export class SecurityMergePriorityColumns {
        static columnsKey = 'Data.SecurityMergePriority';
    }
}
